import React, { useEffect } from 'react';
import { requestHostWindowLayout } from '../../../shared/lib/utils/windowSizing';
import QuickFillPage from './QuickFillPage';

const QuickFillWorkspacePage: React.FC<React.ComponentProps<typeof QuickFillPage>> = (props) => {
  useEffect(() => {
    if (props.embedded) {
      return;
    }

    requestHostWindowLayout('CenterPanel');
  }, [props.embedded]);

  return <QuickFillPage {...props} />;
};

export default QuickFillWorkspacePage;
